import React from "react";
import { Film, MessageCircle, MessageSquare, Newspaper, Users } from "lucide-react";
import StepTab from "./StepTab";
import { FEED_ENABLED } from "../utils/features";

export type WorkspaceMode = "council" | "chat" | "feed" | "video";

export function Brand() {
  return (
    <div className="brand-lockup">
      <span className="brand-symbol" aria-hidden="true"><MessageCircle size={23} strokeWidth={1.8} /><span /></span>
      <span><strong>AI Debate Council</strong></span>
    </div>
  );
}

export default function WorkspaceNavigation({ active, onChange }: {
  /** Absent on pages outside the four workspaces, such as a shared debate. */
  active?: WorkspaceMode;
  onChange: (mode: WorkspaceMode) => void;
}) {
  return (
    <nav className="workspace-navigation" aria-label="Workspace">
      <StepTab selector=".workspace-nav-item.is-active" activeKey={active ?? "none"} axis="horizontal" continuityKey="workspace-navigation" />
      {([
        ["council", "Debate Council", Users],
        ["chat", "Direct Chat", MessageSquare],
        ...(FEED_ENABLED ? [["feed", "Feed", Newspaper] as const] : []),
        ["video", "Video Studio", Film],
      ] as const).map(([mode, label, Icon]) => (
        <button key={mode} type="button" aria-current={active === mode ? "page" : undefined}
          className={`workspace-nav-item ${active === mode ? "is-active" : ""}`}
          onClick={() => onChange(mode)}>
          <Icon size={17} strokeWidth={1.8} /><span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
